export default [
  {
    id: 'hdx_delivery_1',
    deliveryCode: '0hdx1234567891',
    storeStatus: 'awaiting stock',
    orderStatus: [
      'Ordered',
      'Booked',
      'Confirmed',
      'Out for Delivery',
      'Delivered',
    ],
    arrivalExpectedDate: 'May 21',
    arrivalExpectedTime: '10am - 2pm',
    deliveryNote:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla aliquet, ligula sed tinc id unt aliquam, tortor nibh pretium risus, et semper magna dui sit amet ipsum. Vestibulum commodo fringilla est, et fermentum ligula rutrum ac.',
  },
  {
    id: 'hdx_delivery_2',
    deliveryCode: '0hdx1234567892',
    storeStatus: 'awaiting stock',
    orderStatus: [
      'Ordered',
      'Booked',
      'Confirmed',
      'Out for Delivery',
      'Delivered',
    ],
    arrivalExpectedDate: 'May 21',
    arrivalExpectedTime: '10am - 2pm',
    deliveryNote:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla aliquet, ligula sed tinc id unt aliquam, tortor nibh pretium risus, et semper magna dui sit amet ipsum. Vestibulum commodo fringilla est, et fermentum ligula rutrum ac.',
  },
  {
    id: 'hdx_delivery_3',
    deliveryCode: '0hdx1234567893',
    storeStatus: 'awaiting stock',
    orderStatus: [
      'Ordered',
      'Booked',
      'Confirmed',
      'Out for Delivery',
      'Delivered',
    ],
    arrivalExpectedDate: 'May 21',
    arrivalExpectedTime: '10am - 2pm',
    deliveryNote:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla aliquet, ligula sed tinc id unt aliquam, tortor nibh pretium risus, et semper magna dui sit amet ipsum. Vestibulum commodo fringilla est, et fermentum ligula rutrum ac.',
  },
]
